export default {
    login: 'Connexion',
    registration: 'Inscription',
    order: 'Mes commandes',
    language: 'Français',
    home: 'Accueil',
    babyToys: 'Mots-clés',
    aboutus: 'À propos',
    product: 'Produits',
    cart: 'Panier',
    contactus: 'Contact',
    comprehensiveInquiry: 'Recherche globale',
    advancedSearch: 'Recherche avancée',
    productName: 'Nom produit',
    priceRange: 'Fourchette prix',
    reset: 'Réinitialiser',
    search: 'Rechercher',
    classify: 'Catégoriser',
    categories: 'Catégories',
    close: 'Replier',
    open: 'Déplier',
    updateTime: 'MàJ',
    startTime: 'Date début',
    endTime: 'Date fin',
    confirm: 'Confirmer',
    minimumPrice: 'Prix min',
    highestPrice: 'Prix max',
    L: 'Long',
    W: 'Larg',
    H: 'Haut',
    inputPlaceholder: 'Saisissez un texte',
    selectPlaceholder: 'Choisissez une option',
    packingCapacity: 'Quantité par carton',
    price: 'Prix',
    itemNo: 'Ref usine',
    packing: 'Emballage',
    productSize: 'Dim produit',
    packageSize: 'Dim emballage',
    cartonSize: 'Dim carton',
    innerBoxAndOuterPacking: 'Boîte int / carton',
    OuterPacking: "Quantité carton",
    CBMAndCUFT: 'Vol / Cubage',
    CUFT: 'Cubage',
    CBM: 'Volume',
    GWAndNW: 'Poids brut / net',
    mOQ: 'Qté min commande',
    productInformation: 'Infos produit',
    relatedProducts: 'Produits liés',
    more: 'Plus',
    clear: 'Vider',
    inputPassword: 'Saisissez mot de passe',
    passwordLength: 'Au moins 6 caractères',
    inputUserName: 'Saisissez votre nom',
    inputUserAccount: 'Saisissez identifiant',
    inputVaildeCode: 'Saisissez code vérif',
    inputMobile: 'Saisissez téléphone',
    inputEmail: 'Saisissez email',
    inputEmailRules: 'Email invalide',
    password: 'Mot de passe',
    username: 'Nom',
    vaildecode: 'Code vérif',
    gender: 'Sexe',
    useraccount: 'Identifiant',
    man: 'Homme',
    woman: 'Femme',
    mobile: 'Téléphone',
    email: 'Email',
    address: 'Adresse contact',
    CodeError: 'Code invalide',
    resUserError: 'Identifiant existant',
    notreviewed: 'Compte non validé',
    loginError: 'Identifiant ou mot de passe erroné',
    loginSuccess: 'Connexion OK',
    regSuccess: 'Inscription OK',
    deleteSuccess: 'Supprimé OK',
    toregister: 'Pas de compte ? S\'inscrire',
    toLogin: 'Déjà un compte ? Connexion',
    logout: 'Déconnexion',
    myShoppingCart: 'Mon panier',
    ID: 'N°',
    picture: 'Image',
    ItemNO: 'Référence',
    name: 'Nom',
    total: 'Total',
    delete: 'Supprimer',
    CTNS: 'Nb cartons',
    checkAll: 'Tout sélectionner',
    checkSelect: 'Ajouter sélection au panier',
    page: 'Page',
    goTO: 'Aller à',
    totalRecords: 'Total références',
    totalCTNS: 'Total cartons',
    totalQuantity: 'Total quantité',
    totalPrice: 'Total prix',
    submit: 'Valider',
    orderDetails: 'Détails commande',
    OrderInformation: 'Infos commande',
    number: 'N° commande',
    orderTime: 'Date commande',
    linkman: 'Contact',
    remark: 'Commentaire',
    viewDetails: 'Voir détails',
    companyContact: 'Contact société',
    companyTel: 'Tél',
    companyFax: 'Fax',
    companyMail: 'Email société',
    companyAddress: 'Adresse société',
    productCenter: 'Produits',
    helpCenter: 'Aide',
    member: 'Espace membre',
    productdemand: 'Demande produit',
    newproduct: 'Nouveaux produits',
    registerhelp: 'Aide inscription',
    orderhelp: 'Aide commande',
    newproducts: 'Nouveautés',
    highRec: 'Recommandés',
    slogan: 'Meilleurs ventes 2023',
    viewmore: 'Voir plus',
    videocenter: 'Vidéos',
    videoSlogan: 'Découvrez le jouet',
    searchPicture: 'Recherche image',
    choosePicture: 'Choisir image',
    clickOrDrag: 'Glisser ou cliquer',
    copyPicture: 'Copier image Ctrl+V',
    pictureCrop: 'Recadrage',
    cancel: 'Annuler',
    pleaseLogin: 'Connectez-vous',
    addCart: "Ajouter au panier",
    delCart: "Retirer du panier",
    viewPrice: 'Voir prix',
    noData: 'Aucune donnée',
    systemTip: 'Info système',
    deleteData: 'Supprimer cette ligne ?',
    clearCartData: 'Vider tout le panier ?',
    orderSuccess: 'Commande créée',
    submitTip: 'Valider la commande ?',
    noLogin: 'Connectez-vous avant ajout panier',
    notImage: 'Ce n\'est pas une image',
    noSelect: 'Sélectionnez une ligne',
    hotSaleProduct: 'Best-sellers',
    popularRecommendation: 'Populaires',
    please_contact_us: 'Contactez-nous par tél ou fax',
    ock_email: 'Email',
    contactUs: 'Nous contacter',
    hotLine: 'Ligne directe',
    companyAddres: 'Adresse société',
    workingHours: 'Horaires',
    week: 'Lun-Ven',
    companyInfo: 'Présentation société',
    noName: 'Sans traduction',
    serviceHotine: "Assistance 24h/7j",
    success: "Ajout OK",
    del: "Supprimé OK",
    orderStatus: 'Statut commande',
    sendDate: 'Date expédition',
    expressNumber: 'N° suivi',
    unshipped: 'Non expédié',
    shipped: 'Expédié',
    Disclaimer: "Copyright fabricant, droits réservés",
    Technic: 'Assistance technique',
    Software: 'Shenzhen Hongsheng Software',
    coNuNum: "N° société",
    all: 'Toutes catégories',
    userAddress: 'Adresse livraison',
    consignee: 'Destinataire',
    addressDetail: 'Complément adresse',
    addressinformation: 'Infos livraison',
    defaultAddress: 'Par défaut',
    defaultSettings: 'Définir par défaut',
    edit: 'Modifier',
    add: 'Ajouter',
    AddinganAddress: 'Ajouter adresse',
    Edittheaddress: 'Modifier adresse',
    Ok: 'Enregistrer',
    Address_Consignee: 'Saisissez destinataire',
    Address_Mobile: 'Saisissez téléphone',
    Address_Address: 'Saisissez adresse',
    PleaseContact: 'Saisissez contact',
    Video_playback: 'Lecture vidéo'
}